import {createFeatureSelector} from '@ngrx/store';
import {InvitationsState} from './invitations.state';

export const selectInvitationsState = createFeatureSelector<InvitationsState>('core-portal-feature-settings-invitations');
